import React from 'react';
import type { PersonalOverlayMode } from './types';
import styles from '../ControlBridge.module.css';

export interface PersonalLayerOverlayToggleProps {
  mode: PersonalOverlayMode;
  onChange: (mode: PersonalOverlayMode) => void;
}

export const PersonalLayerOverlayToggle: React.FC<PersonalLayerOverlayToggleProps> = ({
  mode,
  onChange,
}) => (
  <div className={styles.personalLayerToggle} role="group" aria-label="Personal layer overlay">
    <button
      type="button"
      className={`${styles.personalLayerToggleBtn} ${mode === 'system' ? styles.personalLayerToggleBtnActive : ''}`}
      aria-pressed={mode === 'system'}
      onClick={() => onChange('system')}
    >
      System
    </button>
    <button
      type="button"
      className={`${styles.personalLayerToggleBtn} ${mode === 'me' ? styles.personalLayerToggleBtnActive : ''}`}
      aria-pressed={mode === 'me'}
      onClick={() => onChange('me')}
    >
      Me
    </button>
  </div>
);
